import _ from "lodash"
import {TROLLEY_COMMITS} from "@/store/contracts" 
const state= {
    /**
     * [
     *  {topProjectId:xx, projectId:xx, path:xxx, title:xx}
     * ]
     */
    projects: []
}
function projectEqual(proj1, proj2){
    return proj1.topProjectId===proj2.topProjectId && proj1.projectId===proj2.projectId
}
function exist(proj){
    for (let i = 0; i < state.projects.length; i++) {
        const eProj = state.projects[i];
        if(projectEqual(eProj, proj)){
            return true
        }        
    }
    return false
}
const mutations={
    [TROLLEY_COMMITS.PUT_IN]: function(state, projects){
        if(!_.isArray(projects)){
            projects = [projects]
        }
        projects.forEach(proj=>{
            if(!exist(proj)){
                state.projects.push(proj)
            }
        })
        
    },
    [TROLLEY_COMMITS.TAKE_OUT]: function(state, projects){
        if(!_.isArray(projects)){
            projects = [projects]
        }
        projects.forEach(project => {
            for (let i = state.projects.length-1; i >=0 ; i--) {
                const existProj = state.projects[i];
                if(projectEqual(existProj, project)){
                    state.projects.splice(i, 1)
                    break;
                }
            }
        });
    }
}
const actions={}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}